import Location from "../../hooks/Location"
import { useFirestoreGeneralOrderBy, useFirestoreID, useFirestoreGeneral } from "../../firebase/useFirestore"
import { useState, useEffect, useContext, useRef } from 'react';
import { db, timestamp } from "../../firebase/config";
import { client } from "../../hooks/Client";
import uuid from 'react-uuid';
import ScrollToTop from "../../hooks/ScrollToTop";
import { SavedIcon } from "../../StateManagment/SavedIcon";
import plusButton from '../../images/icons/plus-icon.png'
import { useHistory } from "react-router-dom";
import useSettings from "../../hooks/Settings";
import { QuestionaireFieldsSystemMessage, QuestionaireFieldsToolCallContent, QuestionaireFieldsSaveMessage } from "../../hooks/impactAI/Prompts"
import { Auth } from '../../StateManagment/Auth';
import { ImpactAI } from "../../StateManagment/ImpactAI";
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined';
import PremiumIcon from "../../components/common/PremiumIcon";
import OrderQuestionnaireFieldsView from "../../components/Questionnaire/OrderQuestionnaireFieldsView";
import MeetstandardIcon from '../../images/meetstandaard-icon.png'
import PageHeader from "../../components/layout/PageHeader.jsx";
import Modal from "../../components/common/Modal";
import ReadOnlyGuard from "../../components/common/ReadOnlyGuard";
import notDeleted from "../../helpers/notDeleted";
import questionnaireBuilderPath from "../../helpers/questionnaire/questionnaireBuilderPath";
import { sentinelToEmpty } from "../../helpers/sentinelValue";
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import ViewAgendaOutlinedIcon from '@mui/icons-material/ViewAgendaOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';
import clickableRowProps from '../../helpers/a11y/clickableRowProps';

const QuestionaireBuilder = () => {
    // Context
    const [saved, setSaved] = useContext(SavedIcon)
    const [auth] = useContext(Auth)
    const {
        type: [type, setType],
        systemMessage: [systemMessage, setSystemMessage],
        toolCallContent: [toolCallContent, setToolCallContent],
        collection: [collection, setCollection],
        docid: [docid, setDocid],
        field: [field, setField],
        saveMessage: [saveMessage, setSaveMessage],
        startMessage: [startMessage, setStartMessage],
        parentId: [parentId, setParentId],
        exampleMessages: [exampleMessages, setExampleMessages],
        chatOpen: [chatOpen, setChatOpen],
        hightlighted: [hightlighted, setHightlighted],
        hightlightText: [hightlightText, setHightlightText],
        position: [position, setPosition],
    } = useContext(ImpactAI);

    // State
    const [title, setTitle ] = useState('')
    const [pageDocid, setPageDocid ] = useState('')
    const [itemArray, setItemArray] = useState([])
    const [ID, setID] = useState('')
    const [questionniareDescription, setQuestionnaireDescription] = useState('')
    const [targetgroupID, setTargetgroupID] = useState(null)
    const [targetgroupTitle, setTargetgroupTitle] = useState('')
    const [targergroupEffects, setTargetgroupEffects] = useState('')
    const [showAddContainer, setShowAddContainer] = useState(false)
    const [descriptionOpen, setDescriptionOpen] = useState(false)

    // Guards the one-time CompagnyID backfill so it can't re-fire on every snapshot.
    const compagnyIdBackfilled = useRef(false)

    // Hooks
    const questionaireId = Location()[3]
    // Vanuit 'Vragenlijsten' geopend staat er geen onderzoek in de URL; haal het
    // dan op via de vragenlijst, zodat de subpagina's het wél meekrijgen (B5).
    const urlResearchID = sentinelToEmpty(Location()[4])
    const linkedResearch = useFirestoreGeneral('Research', 'QuestionnaireID', urlResearchID ? '' : (questionaireId || ''))
    const researchID = urlResearchID || linkedResearch?.[0]?.ID || ''
    ScrollToTop()
    const history = useHistory()
    const { TertairyColor, subscription } = useSettings()

    // Firestore
    const questionnares = useFirestoreID('Questionnaires', questionaireId || '')
    const questionnaireFields = useFirestoreGeneralOrderBy('QuestionnaireFields', 'QuestionnaireID', questionaireId || '', 'Position', 'asc')
    const research = useFirestoreID('Research', researchID ? researchID : '')
    const targetgroups = useFirestoreID('Stakeholders', targetgroupID ? targetgroupID : '')
    const effects = useFirestoreGeneral('OutputEffects', 'Targetgroup', targetgroupID ? targetgroupID : '')

    //ImpactAI
    const pageSystemMessage = QuestionaireFieldsSystemMessage(title, targergroupEffects, targetgroupTitle)
    const pageToolCallContent = QuestionaireFieldsToolCallContent()
    const pageSaveMessage = QuestionaireFieldsSaveMessage()
    const pageStartMessage = `Hoi ${auth?.ForName}. Hier gaan we de vragen creëeren voor de vragenlijst '${title}'.
    Zal ik een voorstel doen?`
    const pageCollection = 'QuestionnaireFields'
    const pageField = 'Question'
    const pageType = 'questionaireFields' + ID

    useEffect(() => {
        setType(pageType)
        setSystemMessage(pageSystemMessage)
        setStartMessage(pageStartMessage)
        setToolCallContent(pageToolCallContent)
        setSaveMessage(pageSaveMessage)
        setCollection(pageCollection)
        setField(pageField)
        setParentId(ID)
        setExampleMessages([])
        setDocid(pageDocid)
        setPosition(questionnaireFields.length + 1)
    }, [auth, targergroupEffects, targetgroupTitle, questionnaireFields])


    // Set the targetgroupID in state
    useEffect(() => {
        research && setTargetgroupID(research[0]?.TargetgroupID)
    }, [research])

    // Set the targetgroup title in state
    useEffect(() => {
        targetgroups && setTargetgroupTitle(targetgroups[0]?.Organisation)
    }, [targetgroups])

    // Set the targetgroup effects in state
    useEffect(() => {

        const array = []

        effects && effects.forEach(effect => {
            array.push(effect.Effect)
        })

        setTargetgroupEffects(array.join(', '))

    }, [effects])

    // One-time backfill for legacy fields created before CompagnyID was written
    // on creation. Every writer now sets CompagnyID, so this only touches old
    // docs that are missing it. Guarded by a ref + a missing-only filter so it
    // never re-fires on snapshot updates (which caused a write-amplification loop).
    useEffect(() => {
        if (compagnyIdBackfilled.current) return
        if (!questionnaireFields || questionnaireFields.length === 0) return

        compagnyIdBackfilled.current = true

        questionnaireFields
            .filter(field => !field.CompagnyID)
            .forEach(field => {
                db.collection('QuestionnaireFields')
                .doc(field.docid)
                .update({
                    CompagnyID: field.Compagny || client
                })
            })
    }, [questionnaireFields])

    // Set title, docid, ID and description of questionaire to state
    useEffect(() => {
        questionnares && questionnares.forEach(questionnare => {
            setTitle(questionnare.Title)
            setPageDocid(questionnare.docid)
            setID(questionnare.ID)
            setQuestionnaireDescription(questionnare.Description)
        })
    }, [questionnares])

    // Set fields array
    useEffect(() => {
        const array = []
        questionnaireFields && questionnaireFields.forEach(item => {
            const object = {
                fieldDocid: item.docid
            }
            array.push(object)
        })
        setItemArray(array)
    },[questionnaireFields])

    // Update questionaire title
    const titleHandler = (e) => {

        const title = e.target.value 

        setTitle(title)

        db.collection('Questionnaires')
        .doc(docid)
        .update({
            Title: title
        })
        .then(() => {
            setSaved('flex')
         })
    }

    // Add field to database
    const addField = (e) => {

        const position = questionnaireFields.length + 1

        db.collection('QuestionnaireFields')
        .doc()
        .set({
            Compagny: client,
            CompagnyID: client,
            ID: uuid(),
            Timestamp: timestamp,
            QuestionnaireID: questionaireId,
            Type: 'paragraph',
            Question: 'Vraag ' + position,
            Explainer: '',
            ReachStart: 0,
            ReachStartLable: '',
            ReachEnd: 5,
            ReachEndLabel: '',
            Key: uuid(),
            Position: position,
            Multiple: [],
            SectionID: '',
            LiveReportHidden: false,
        })
    }

    // Update questionaire description
    const descriptionHandler = (e) => {
        const description = e.target.value

        db.collection('Questionnaires')
        .doc(docid)
        .update({
            Description: description
        })
        .then(() => {
            setSaved('flex')
        })
    }

    // Add a section to the questionnaire (and database)
    const addSection = () => {

        const position = questionnaireFields.length + 1

        db.collection('QuestionnaireFields')
        .doc()
        .set({
            Compagny: client,
            CompagnyID: client,
            ID: uuid(),
            Timestamp: timestamp,
            QuestionnaireID: questionaireId,
            Type: 'section',
            Question: 'Sectietitel',
            Explainer: '',
            ReachStart: 0,
            ReachStartLable: '',
            ReachEnd: 5,
            ReachEndLabel: '',
            Key: uuid(),
            Position: position,
            Multiple: [],
            SectionID: '',
            Color: TertairyColor,
            Title: 'Sectietitel',
        })
    }

  // Visible (not soft-deleted) fields drive the stat chips.
  const visibleFields = (questionnaireFields || []).filter(notDeleted)
  const sectionCount = visibleFields.filter(f => f.Type === 'section').length
  const questionCount = visibleFields.filter(f => f.Type !== 'section').length
  const hasFields = (questionnaireFields || []).length > 0

  return (
    <div className="main">
        <div className="main-container" >
          <ReadOnlyGuard edit="measurement.edit">
            {(canEdit) => (
              <div className="qb-redesign">

                <PageHeader
                    heading={'Vragenlijst instellingen'}
                    description={`Op deze pagina kun je de instellingen van de vragenlijst beheren.`}
                    AI={false}
                />

                {/* ---------- Header ---------- */}
                <div className="qb-head">
                    <div className="qb-head-main">
                        <input
                            className="qb-title-input"
                            type="text"
                            placeholder="Titel vragenlijst"
                            defaultValue={title}
                            onChange={titleHandler}
                            aria-label="Vragenlijst titel"
                        />
                    </div>
                </div>

                {/* ---------- Description (collapsible) ---------- */}
                <div className={`qb-desc ${descriptionOpen ? 'open' : ''}`}>
                    <button className="qb-desc-toggle" onClick={() => setDescriptionOpen(prev => !prev)}>
                        <ChevronRightOutlinedIcon />
                        Omschrijving
                    </button>
                    <textarea
                        className="qb-desc-input"
                        placeholder="Voeg een omschrijving toe van je vragenlijst"
                        defaultValue={questionniareDescription}
                        onChange={descriptionHandler}
                    ></textarea>
                </div>

                {/* ---------- Stat chips ---------- */}
                <div className="qb-stat-row">
                    <span className="qb-chip"><ViewAgendaOutlinedIcon /><strong>{sectionCount}</strong> secties</span>
                    <span className="qb-chip"><HelpOutlineOutlinedIcon /><strong>{questionCount}</strong> vragen</span>
                </div>

                {/* ---------- Fields ---------- */}
                <OrderQuestionnaireFieldsView questionnaireFields={questionnaireFields} />

                {/* ---------- Add-options modal ---------- */}
                <Modal
                    modalOpen={showAddContainer}
                    setModalOpen={setShowAddContainer}
                    pageHeader={'Vraag toevoegen'}
                    hideConfirm={true}
                    content={
                        <div className="qb-redesign-modal">
                            <div className="add-options-container-item-container" {...clickableRowProps(() => { setShowAddContainer(false); history.push(questionnaireBuilderPath(client, 'addstandardeffectstoquestionaire', questionaireId, researchID)); })}>
                                <div className="add-options-container-item-icon">
                                    <img src={MeetstandardIcon} alt="" />
                                    <p>Gestandaardiseerde effecten toevoegen</p>
                                </div>
                            </div>
                            <div className="add-options-container-item-container" {...clickableRowProps(subscription === 'free' ? null : () => { setShowAddContainer(false); history.push(questionnaireBuilderPath(client, 'addindicatorstoquestionaire', questionaireId, researchID)); })}>
                                <div className="add-options-container-item-icon">
                                    <img src={plusButton} alt="" />
                                    <p>Gekoppelde vragen toevoegen</p>
                                </div>
                                <PremiumIcon />
                            </div>
                            <div className="add-options-container-item-container" {...clickableRowProps(subscription === 'free' ? null : () => { setShowAddContainer(false); addField(); })}>
                                <div className="add-options-container-item-icon">
                                    <img src={plusButton} alt="" />
                                    <p>Ongekoppelde vraag toevoegen</p>
                                </div>
                                <PremiumIcon />
                            </div>
                            <div className="add-options-container-item-container" {...clickableRowProps(subscription === 'free' ? null : () => { setShowAddContainer(false); history.push(questionnaireBuilderPath(client, 'addonstructuredinterview', questionaireId, researchID)); })}>
                                <div className="add-options-container-item-icon">
                                    <img src={plusButton} alt="" />
                                    <p>Ongestructureerd interview toevoegen</p>
                                </div>
                                <PremiumIcon />
                            </div>
                            <div className="add-options-container-item-container" {...clickableRowProps(() => { setShowAddContainer(false); addSection(); })}>
                                <div className="add-options-container-item-icon">
                                    <ListAltOutlinedIcon />
                                    <p>Sectie toevoegen</p>
                                </div>
                            </div>
                        </div>
                    }
                />

                {/* ---------- Floating action bar ---------- */}
                <div className="qb-actionbar">
                    {canEdit && (
                        <>
                            <button className="qb-bar-btn primary" onClick={() => setShowAddContainer(true)}>
                                <AddOutlinedIcon />Vraag
                            </button>
                            <button className="qb-bar-btn" onClick={addSection}>
                                <ViewAgendaOutlinedIcon />Sectie
                            </button>
                        </>
                    )}
                    {hasFields && (
                        <>
                            {canEdit && <span className="qb-bar-sep"></span>}
                            {/* Het onderzoek hoort in het 5e segment; hier stond de vragenlijst-ID,
                                waardoor de voorbeeldweergave nooit het echte onderzoek vond en dus
                                altijd op de oude look terugviel (updateverzoek 2026-09-10). */}
                            <button className="qb-bar-btn" onClick={() => window.open(`/${client}/questionnaireopen/${ID}/${ID}/${researchID || ID}/open/test/nl`, '_blank')}>
                                <VisibilityOutlinedIcon />Voorbeeld
                            </button>
                        </>
                    )}
                </div>

              </div>
            )}
          </ReadOnlyGuard>
        </div>
    </div>
  )
}

export default QuestionaireBuilder